module.exports = __webpack_public_path__ + "img/PD_3.4707a1fe.png";